import { render } from "./tickets-details.vue?vue&type=template&id=f5d8a16a"
import script from "./tickets-details.vue?vue&type=script&lang=js"
export * from "./tickets-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__